import { render, staticRenderFns } from "./ModalLinkedPositionsDraft.vue?vue&type=template&id=420017fa&"
import script from "./ModalLinkedPositionsDraft.vue?vue&type=script&lang=js&"
export * from "./ModalLinkedPositionsDraft.vue?vue&type=script&lang=js&"
import style0 from "./ModalLinkedPositionsDraft.vue?vue&type=style&index=0&id=420017fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports